import { 
  Page, 
  Layout, 
  Card, 
  Text, 
  BlockStack, 
  Banner,
  Box,
  Spinner,
  List
} from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useShop } from '../context/ShopContext';
import { EmailSettings } from '../components/EmailSettings';

export default function SettingsPageSimple() {
  const navigate = useNavigate();
  const { shop, isLoading } = useShop();
  const { t } = useTranslation();

  if (!shop) {
    return (
      <Page>
        <Banner tone="warning" title={t('dashboard.errors.shopNotFound')}>
          <p>{t('dashboard.errors.shopNotFoundDesc')}</p>
        </Banner>
      </Page>
    );
  }

  if (isLoading) {
    return (
      <Page>
        <Box padding="800">
          <BlockStack gap="400" align="center">
            <Spinner size="large" />
            <Text as="p">{t('settings.loadingSettings')}</Text>
          </BlockStack>
        </Box>
      </Page>
    );
  }

  return (
    <Page
      title={t('settings.title')}
      backAction={{ content: t('common.back'), onAction: () => navigate('/app') }}
    >
      <Layout>
        {/* Info Banner */}
        <Layout.Section>
          <Banner tone="info">
            <p>
              <strong>{t('settings.widgetStylingInfo')}</strong> {t('settings.widgetStylingPath')}
            </p>
          </Banner>
        </Layout.Section>

        {/* Email Recommendations - with SPF/DKIM setup */}
        <Layout.Section>
          <EmailSettings />
        </Layout.Section>

        {/* How Recommendations Work */}
        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h2" variant="headingMd">{t('settings.howAiWorks')}</Text>
              <List>
                <List.Item>
                  <strong>{t('settings.similarProducts')}:</strong> {t('settings.similarProductsDesc')}
                </List.Item>
                <List.Item>
                  <strong>{t('settings.fbt')}:</strong> {t('settings.fbtDesc')}
                </List.Item>
                <List.Item>
                  <strong>{t('settings.personalized')}:</strong> {t('settings.personalizedDesc')}
                </List.Item>
                <List.Item>
                  <strong>{t('settings.trending')}:</strong> {t('settings.trendingDesc')}
                </List.Item>
              </List>
              <Text as="p" tone="subdued">
                {t('settings.aiLearnsAuto')}
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
